import { createFrontendPlugin } from '@backstage/frontend-plugin-api';
import { EntityContentBlueprint } from '@backstage/plugin-catalog-react/alpha';
import { isOrganisationDsoEntity } from '@ipen-portal/ipen-entity-model';
import { TrpcApiBlueprint } from '@ipen-portal/plugin-trpc-react';

import { iamApiRef } from './apis';

export const iamPlugin = createFrontendPlugin({
  extensions: [
    TrpcApiBlueprint.make({
      name: 'iam-api',
      params: defineParams =>
        defineParams({
          apiRef: iamApiRef,
          getHeaders: async ({ api, config }) => ({
            'X-Entra-Assertion': await api.getAccessToken(
              `api://${config.getString('catalog.providers.microsoftGraphOrg.ipen.clientId')}/.default`,
            ),
          }),
          path: 'iam/trpc',
          useBatch: false,
        }),
    }),
    EntityContentBlueprint.make({
      name: 'iam',
      params: {
        filter: isOrganisationDsoEntity,
        loader: async () => {
          const { IamPage } = await import('./components/IamPage');
          return <IamPage />;
        },
        path: '/iam',
        title: 'IAM',
      },
    }),
  ],
  pluginId: 'iam',
});
